import React, { useState } from "react";
import { X, Play } from "lucide-react";
import "./Gallery.css";

// Import images
import img1 from "../asset/asset_psd/img_1.jpg";
import img2 from "../asset/asset_psd/img_2.jpg";
import img3 from "../asset/asset_psd/img_3.jpg";
import img4 from "../asset/asset_psd/img_4.jpg";
import img5 from "../asset/asset_psd/img_5.jpg";
import img6 from "../asset/asset_psd/img_6.jpg";
import img7 from "../asset/asset_psd/img_7.jpg";
import img8 from "../asset/asset_psd/img_8.jpg";
import img9 from "../asset/asset_psd/img_9.jpg";
import img10 from "../asset/asset_psd/img_10.jpg";
import img11 from "../asset/asset_psd/img_11.jpg";
import img12 from "../asset/asset_psd/img_12.jpg";
import img13 from "../asset/asset_psd/img_13.jpg";
import img14 from "../asset/asset_psd/img_14.jpg";
import img15 from "../asset/asset_psd/img_15.jpg";
import img16 from "../asset/asset_psd/img_16.jpg";
import img17 from "../asset/asset_psd/img_17.jpg";
import img18 from "../asset/asset_psd/img_18.jpg";
import img19 from "../asset/asset_psd/img_19.jpg";
import img20 from "../asset/asset_psd/img_20.jpg";
import img21 from "../asset/asset_psd/img_21.jpg";

// Import videos
import video22 from "../asset/asset_psd/ved_22.mp4";
import video23 from "../asset/asset_psd/ved_23.mp4";
import video24 from "../asset/asset_psd/ved_24.mp4";
import video25 from "../asset/asset_psd/ved_25.mp4";
import video26 from "../asset/asset_psd/ved_26.mp4";
import video27 from "../asset/asset_psd/ved_27.mp4";

const Gallery = () => {
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxVideo, setLightboxVideo] = useState(null);

  // Gallery images
  const images = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
  ];

  // Gallery videos
  const videos = [video22, video23, video24, video25, video26, video27];

  const openImageLightbox = (image) => {
    setLightboxImage(image);
  };

  const openVideoLightbox = (video) => {
    setLightboxVideo(video);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    setLightboxVideo(null);
  };

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <div className="gallery-hero-content">
          <h1 className="gallery-hero-title">Our Gallery</h1>
          <p className="gallery-hero-subtitle">
            Explore Our Portfolio of Bespoke Creations
          </p>
        </div>
      </section>

      {/* Images Section */}
      <section className="gallery-section">
        <div className="gallery-container">
          <div className="gallery-section-header">
            <h2 className="gallery-section-title">Featured Designs</h2>
            <p className="gallery-section-description">
              A showcase of our custom tailoring, bridal couture, and intricate
              Aari work
            </p>
          </div>

          <div className="gallery-grid gallery-grid-images">
            {images.map((image, index) => (
              <div
                key={index}
                className="gallery-item gallery-image-item"
                onClick={() => openImageLightbox(image)}
              >
                <img
                  src={image}
                  alt={`Fashion design ${index + 1}`}
                  className="gallery-image"
                />
                <div className="gallery-overlay">
                  <span>View Image</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Videos Section */}
      <section className="gallery-section gallery-section-alt">
        <div className="gallery-container">
          <div className="gallery-section-header">
            <h2 className="gallery-section-title">Videos</h2>
            <p className="gallery-section-description">
              Watch our craftsmanship come to life
            </p>
          </div>

          <div className="gallery-grid gallery-grid-videos">
            {videos.map((video, index) => (
              <div
                key={index}
                className="gallery-item gallery-video-item"
                onClick={() => openVideoLightbox(video)}
              >
                <video
                  src={video}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="gallery-video-thumbnail"
                  preload="metadata"
                />
                <div className="gallery-video-overlay">
                  <div className="gallery-play-button">
                    <Play size={32} fill="white" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Lightbox */}
      {lightboxImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" aria-label="Close">
            <X size={32} />
          </button>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightboxImage}
              alt="Full size"
              className="lightbox-image"
            />
          </div>
        </div>
      )}

      {/* Video Lightbox */}
      {lightboxVideo && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" aria-label="Close">
            <X size={32} />
          </button>
          <div
            className="lightbox-content lightbox-video-content"
            onClick={(e) => e.stopPropagation()}
          >
            <video
              src={lightboxVideo}
              controls
              autoPlay
              muted
              className="lightbox-video"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
